:host {
  --font-family: 'Montserrat', sans-serif;
  position: relative;
  background: var(--white-layout-301-level-0-elevation);
}

.wrapper {
  flex-direction: column;
  height: 100%;
  overflow: auto;
}

.page__header {
  padding: calc(2 * var(--spacer)) calc(2 * var(--spacer)) calc(2 * var(--spacer)) calc(2.5 * var(--spacer));
}

.grid-filters {
  height: auto;
}
.section-title {
  padding: calc(2 * var(--spacer)) calc(2 * var(--spacer)) calc(2 * var(--spacer)) calc(2.5 * var(--spacer));
}

.header-banner {
  display: flex;
  flex-direction: column;
  max-width: 80%;
  min-height: 236px;
  margin-left: calc(var(--spacer) * 2.5);
  margin-bottom: calc(var(--spacer) * 3);
  padding: calc(var(--spacer) * 5) calc(var(--spacer) * 11) calc(var(--spacer) * 5) 340px;
  background-color: var(--blue-layout-400-primary);
  border-radius: 4px;
  position: relative;
  overflow: hidden;

  &:after {
    content: '';
    width: 400px;
    height: 400px;
    background: url('app/webcomponents/assets/images/integrations/banner-image.svg') no-repeat;
    position: absolute;
    left: -70px;
    bottom: -105px;
  }

  #banner-title,
  #banner-text {
    max-width: 700px;
    color: var(--white-layout-301-level-0-elevation);
  }
  #banner-title {
    line-height: 33px;
    margin-bottom: calc(var(--spacer) * 2);
  }
  #banner-text {
    line-height: 21px;
    margin-bottom: calc(var(--spacer) * 3);
  }
}

.content {
  flex-grow: 2;
  height: 100%;

  .grid {
    height: 100%;
  }

  .grid-view {
    min-height: 100%;
    align-items: stretch;

    gz-link {
      --cursorType: pointer;
    }
  }
}

.installed-grid-empty-state {
  margin-bottom: calc(var(--spacer) * 3);
}
#empty-state-installed-grid-title {
  margin-bottom: var(--spacer);
}
